import styled from 'styled-components';
import { space, SpaceProps } from 'styled-system';

const ModalContent = styled.div<SpaceProps>`
  padding: 25px;

  ${space};
`;

export default ModalContent;
